import { render, staticRenderFns } from "./sendToTenant.vue?vue&type=template&id=07f3fec1"
import script from "./sendToTenant.vue?vue&type=script&lang=js"
export * from "./sendToTenant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports